import { NgModule } from '@angular/core';
// import {FormsModule } from '@angular/forms';
// import { HttpClient } from '@angular/common/http';

import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';
import { ThemesModule } from '../themes/themes.module';
import { MarketResearchComponent } from './market-research/market-research.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HealthcareComponent } from './healthcare/healthcare.component';
import { EducationComponent } from './education/education.component';
import { ItandbankingComponent } from './itandbanking/itandbanking.component';
import { HotelandrestaurentsComponent } from './hotelandrestaurents/hotelandrestaurents.component';
import { EventandentertainmentComponent } from './eventandentertainment/eventandentertainment.component';
import { PricingComponent } from './pricing/pricing.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { FaqComponent } from './faq/faq.component';
import { OurClientsComponent } from './our-clients/our-clients.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { GdprComponent } from './gdpr/gdpr.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { PrivacyNoticeComponent } from './privacy-notice/privacy-notice.component';
import { TakedownPolicyComponent } from './takedown-policy/takedown-policy.component';
import { SecurityComponent } from './security/security.component';
import { UnsubscribesComponent } from './unsubscribes/unsubscribes.component';
import { CustomerExperienceComponent } from './customer-experience/customer-experience.component';
import { RetailManufacturingComponent } from './retail-manufacturing/retail-manufacturing.component';
import { EmployeeExperienceComponent } from './employee-experience/employee-experience.component';
import { TemplatesComponent } from './templates/templates.component';
import { FeaturesComponent } from './features/features.component';
import { NpsSurveyComponent } from './nps-survey/nps-survey.component';
import { TemplateDetailsComponent } from './template-details/template-details.component';
import { TemplateQuestionDetailsComponent } from './template-question-details/template-question-details.component';
import { TempQuestionComponent } from './temp-question/temp-question.component';
import { BlogComponent } from './blog/blog.component';
import { BlogDetailsComponent } from './blog-details/blog-details.component';
import { ZohoSalesiqComponent } from './zoho-saleiq/zoho-salesiq.component';
import { DeveloperComponent } from './developer/developer.component';
import {Ng2PageScrollModule} from 'ng2-page-scroll';

@NgModule({
  declarations: [
    HomeComponent,
    PagesComponent,
    MarketResearchComponent,
    PageNotFoundComponent,
    HealthcareComponent,
    EducationComponent,
    ItandbankingComponent,
    HotelandrestaurentsComponent,
    EventandentertainmentComponent,
    PricingComponent,
    HowItWorksComponent,
    FaqComponent,
    OurClientsComponent,
    PrivacyPolicyComponent,
    CookiePolicyComponent,
    GdprComponent,
    TermsOfServiceComponent,
    PrivacyNoticeComponent,
    TakedownPolicyComponent,
    SecurityComponent,
    UnsubscribesComponent,
    CustomerExperienceComponent,
    RetailManufacturingComponent,
    EmployeeExperienceComponent,
    TemplatesComponent,
    FeaturesComponent,
    NpsSurveyComponent,
    TemplateDetailsComponent,
    TemplateQuestionDetailsComponent,
    TempQuestionComponent,
    BlogComponent,
    BlogDetailsComponent,
    ZohoSalesiqComponent,
    DeveloperComponent
  ],

  imports: [
    CommonModule,
    ThemesModule,
    PagesRoutingModule,
    Ng2PageScrollModule
  //  FormsModule
  // HttpClient,
    
  ],
  exports:[    
    HomeComponent,
    PagesComponent,
    MarketResearchComponent,
    PageNotFoundComponent,
    HealthcareComponent,
    EducationComponent,
    ItandbankingComponent,
    HotelandrestaurentsComponent,
    EventandentertainmentComponent,
    PricingComponent,
    NpsSurveyComponent,
    TempQuestionComponent,
    ZohoSalesiqComponent
  ]
})
export class PagesModule { }
